/**
 * Chord matcher.
 *
 * Compares a keyboard event to a declared `KeyChord`. `mod` collapses ⌘/Ctrl
 * into one cross-platform modifier (`e.metaKey || e.ctrlKey`); `shift`/`alt` are
 * matched exactly (absent = must be up). `key` is compared case-insensitively so
 * both `'k'` and the shift-produced `'?'` match their events directly.
 */

import type { KeyChord } from './keybinding.types';

export function matchChord(e: KeyboardEvent | React.KeyboardEvent, chord: KeyChord): boolean {
  if (e.key.toLowerCase() !== chord.key.toLowerCase()) return false;
  if (Boolean(chord.mod) !== (e.metaKey || e.ctrlKey)) return false;
  if (Boolean(chord.shift) !== e.shiftKey) return false;
  if (Boolean(chord.alt) !== e.altKey) return false;
  return true;
}
